module.exports = __webpack_public_path__ + "group_buy/groupbuy_6669-d5b2fb108ece1d8924759bd07408b27d.png";